<template>
    <v-app id="inspire">
        <v-navigation-drawer 
          v-model="drawer"
          color="#FFFFFF"
          app
        >
          <Navigation></Navigation>
        </v-navigation-drawer>
        <v-app-bar 
          app
          color="#004236"
        >
          <v-app-bar-nav-icon @click="drawer = !drawer" color="white"></v-app-bar-nav-icon>
          <v-toolbar-title>
            <span>SFS Admin Portal</span>
          </v-toolbar-title>
        </v-app-bar>

        <v-main>
            <router-view></router-view>
        </v-main>
    </v-app>
</template>
  
  <script>
  import Navigation from '../../../components/Admin/Navigation/Navigation.vue'
  
  export default {
    name: 'AdminApp',
    components: {
      Navigation
    },
    data(){
      return {
        drawer: null
      }
    }
  }
  </script>
  
  <style scoped>
  span{
    color: white;
  }
  </style>